import React from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { IconMapPinPlus } from '@tabler/icons-react'
import { ActionIcon } from '@mantine/core'

// import { useStoreBase } from '@store/index'

import { ModalFormType } from '@customTypes/page'
import { ShortcutType } from '@customTypes/shortcut'

import { useIsMobile } from '@hooks/mobile'

import FloatActions from '@components/shared/floatActions'
import GeoCheckpointForm from '@components/geoCheckpoint/form'
import { RoutesApp } from '@constants/routes'

// import Client from '@pages/private/client'
// import Proforma from '@pages/private/proforma'
// import GeoCheckpoints from '@pages/private/geoCheckpoint'
import Cont from '@components/shared/cont'
import HomeUser from '@components/homeUser'

const Home = () => {
  // const { user } = useStoreBase()

  const isMobile = useIsMobile()

  const navigate = useNavigate()

  const [searchParams] = useSearchParams({
    action: '',
  })

  const [action, setAction] = React.useState<ShortcutType | null>(null)

  const [modalGeoForm, setModalGeoForm] = React.useState<ModalFormType>({
    open: false,
  })

  React.useEffect(() => {
    const action = searchParams.get('action') as ShortcutType
    if (!action) return

    if (action === 'create-geolocation') {
      setModalGeoForm({ open: true })
      setAction(action)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams.toString()])

  return (
    <React.Fragment>
      <Cont fluid className="cd-flex cd-flex-col cd-grow">
        {/* {user?.role === 'admin' && (
          <div className="cd-flex cd-flex-col cd-gap-y-[1rem]">
            <GeoCheckpoints cardPreview />

            <Proforma cardPreview />

            <Client cardPreview />
          </div>
        )} */}

        <HomeUser />

        <GeoCheckpointForm
          modal
          open={modalGeoForm.open}
          size="lg"
          onClose={() => {
            setModalGeoForm({ open: false })
            if (action === 'create-geolocation') {
              navigate(RoutesApp.HOME)
            }
          }}
        />
      </Cont>
      <FloatActions>
        <ActionIcon
          color="blue"
          radius="xl"
          size={isMobile ? 54 : 64}
          onClick={() => setModalGeoForm({ open: true })}
        >
          <IconMapPinPlus size={isMobile ? 24 : 30} />
        </ActionIcon>
      </FloatActions>
    </React.Fragment>
  )
}

export default Home
